<ds-promo-badge tone="green"><ng-content /></ds-promo-badge>
